import classNames from 'classnames'
import { Link } from 'gatsby'
import * as React from 'react'
import { useTocState } from '../../contexts/toc.context'
import { WidgetResolverMultiMemoized, WidgetResolverMultiProps } from '../widget-resolver/widget-resolver.component'
import styleClasses from './widget-toc-section.module.scss'

export type WidgetTocSectionProps = {
  renderToc?: boolean | null
  tocHeading?: string | null
} & WidgetResolverMultiProps

const cnMap: Record<string, string> = {
  h1: styleClasses.boldLink,
  h2: styleClasses.boldLink,
  default: styleClasses.normal,
}

const Toc: React.FC<{ nodes: NonNullable<WidgetResolverMultiProps['nodes']> }> = ({ nodes }) => (
    <>
      {nodes.map(node =>
        node && node.__typename === 'ContentfulHeading' && node.slug ? (
          <Link key={node.id} to={`#${node.slug}`} className={classNames(cnMap[node.variant || ''] || styleClasses.normal)}>
            {node.text}
          </Link>
        ) : null,
      )}
    </>
  )

const WidgetTocSection: React.FC<WidgetTocSectionProps> = ({ nodes, renderToc, children, tocHeading }) => {
  const tocState = useTocState()
  return (
    <section
      className={classNames(styleClasses.container, {
        [styleClasses.noToc]: !nodes?.length || !renderToc,
        [styleClasses.closed]: !tocState,
      })}
    >
      {renderToc && nodes?.length ? (
        <aside className={styleClasses.toc}>
          <div className={styleClasses.tocContent}>
            {tocHeading ? <div className={styleClasses.tocHeading}>{tocHeading}</div> : null}
            <Toc nodes={nodes} />
          </div>
        </aside>
      ) : null}
      <div className={styleClasses.content}>
        <WidgetResolverMultiMemoized nodes={nodes} />
        {children}
      </div>
    </section>
  )
}

export default WidgetTocSection
